import { Pipe, PipeTransform } from '@angular/core';
import { StudyFile } from 'src/app/models/Study/study-file.model';
import { MediaCategory } from 'src/app/models/media/media-category.model';

@Pipe({
  name: 'withCategoryPipe',
  pure: false,
})
export class WithCategoryPipe implements PipeTransform {
  transform(studyFiles: StudyFile[], mediaCategories: MediaCategory[]): any {
    return studyFiles.map((sf) => {
      const category = mediaCategories.find(
        (mc) => mc.id === sf.mediaCategoryId
      );

      return {
        ...sf,
        category,
      };
    });
  }
}
